import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import { initialize, unload } from '../../store/scorm/scorm.js';
import { translate } from '../../helpers/translate.js';
import { launchTypes } from '../../store/elearning/helpers.js';
import '../shared/sdb-spinner.js'

@customElement('sdb-scorm-player')
class SdbScormPlayer extends connect(store)(LitElement)
 {

    @property({ type: String })
    accessor sessionId = null;

    @property({ type: String })
    accessor packageId = null;

    @property({ type: Number })
    accessor launchType = launchTypes.LAUNCHTYPE_REGULAR;

    @state()
    accessor initialized = false;

    @state()
    accessor finished = false;

    @state()
    accessor scormUrl = null;

    @state()
    accessor scormWindow = null;

    get scormWindowIsOpen() {
        return this.scormWindow && !this.scormWindow.closed;
    }

    constructor() {
        super();
        this.scormWindow = null;
    }


    stateChanged(state) {
        this.initialized = state.scorm.initialized;
        this.finished = state.scorm.finished;
        this.enabled = state.scorm.enabled;
        this.scormUrl = state.scorm.url;
    }

    static get styles() {
        return css`
            .scorm-frame {
                width: 100%;
                height: 100%;
                border: none;
                margin: 0;
                padding: 0;
                background: #f7f7f7;
            }

            .newwindow {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .container {
                width: 70%;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: space-between;
            }

            .message {
                font-family: 'Source Sans Pro', 'sans-serif';
            }

            #start_button {
                margin-top: 20px;
            }
        `;
    }

    render() {
        if (!this.initialized) {
            return html`<div class="content"><sdb-spinner></sdb-spinner></div>`;
        }

        if (!this.enabled) {
            return html`
                <div class="content">
                    <sdb-empty-view label=${translate('scormPackageNotEnabled')}></sdb-empty-view>
                </div>
            `;
        }

        if (this.launchType >= launchTypes.LAUNCHTYPE_NEWWINDOW) {
            return html`
                <div class="newwindow">
                    <div class="container">
                        <div class="message">
                            ${translate(this.scormWindowIsOpen
                                ? 'newWindowOpenedMessage'
                                : 'newWindowMessage')
                            }
                        </div>
                        <sdb-content-button
                            id="start_button"
                            label=${translate('startInNewWIndow')}
                            primary
                            ?hidden=${this.scormWindowIsOpen}
                            @click=${async () => await this._openNewWindow()}>
                        </sdb-content-button>
                    </div>
                </div>
            `;
        }

        return html`
            <iframe
                class="scorm-frame"
                src=${this.scormUrl}
                allowfullscreen
                allow="microphone">
            </iframe>
        `;
    }

    async updated(changes) {
        if (changes.has('packageId') || changes.has('sessionId')) {
            if (this.scormWindowIsOpen) {
                this.scormWindow.close();
            }

            if (!this.packageId && !this.finished) {
                store.dispatch(unload());// if close was triggered outside of scormplayer
            }

            if (this.packageId && this.sessionId) {
                store.dispatch(initialize({
                    packageId: this.packageId,
                    sessionId: this.sessionId,
                }));
            }
        }

        if (changes.has('finished') && this.finished) {
            if (this.scormWindow && !this.scormWindow.closed) {
                this.scormWindow.close();
            }

            this.dispatchEvent(new CustomEvent('finish', {
                composed: true,
                bubble: true,
            }));
        }

        if (this.launchType >= launchTypes.LAUNCHTYPE_NEWWINDOW &&
            this.initialized &&
            this.enabled &&
            !this.scormWindowIsOpen) {
            await this._openNewWindow();
        }
    }

    async _openNewWindow() {
        let options = '';
        if (this.launchType === launchTypes.LAUNCHTYPE_NEWCHROMELESSWINDOW) {
            const w = window.screen.availWidth;
            const h = window.screen.availHeight;
            options = `status=0,toolbar=0,menubar=0,resizable=yes,width=${w},height=${h},left=0,top=0`;
        }

        this.scormWindow = window.open(this.scormUrl, 'scormWindow', options);
    }
}
